import React from 'react'
import {appFactory} from '@modifi/app'
import {AUTH_TYPE_ADMIN} from '@modifi/plugin-authentication/register'
import {FullScreenLoader} from '@modifi/ui'
import dataCompositionMiddleware from './data/composition.middleware'
import routes from './routes'
import reducers from './reducers'
import Layout from './layout'
import {initPlugins} from './plugins'
import {withSuspense} from './hoc'
import './dialogs/setup'

const getApp = async (options = {}) => {
  await initPlugins(options?.plugins)

  return appFactory({
    client: 'moneta',
    fullscreenLoader: () => <FullScreenLoader />,
    appType: AUTH_TYPE_ADMIN,
    routes,
    reducers,
    layout: Layout,
    storeMiddlewares: [dataCompositionMiddleware],
    hoc: withSuspense,
  })
}

export default getApp
